import { CONFIG_STATE as t } from "./index2.js";
import { getConfiguration as a } from "../api/services/index.js";
import { createKnownQueryParametersProvider as c } from "../../../libraries/known_query_parameters/index.js";
import { KnownQueryKey as n } from "../../../libraries/known_query_parameters/index3.js";
const u = async () => {
  const { countryCode: d, brand: o } = c().provideParameters(
    n.CountryCode,
    n.Brand
  ), r = d;
  t.switchContext({ countryCode: r, brand: o }), a(o, r).then(
    (e) => {
      e.succeeded && t.set({ values: e.result });
    }
  );
};
export {
  u as loadConfig
};
//# sourceMappingURL=index.js.map
